import type { MyFinanceAccess, User } from '@doorly/shared';
import { useApiQuery } from '../../lib/api';
import { isActingAs } from '../../lib/actingAs';
import { useFeatureFlags } from '../../lib/featureFlags';

const NONE: MyFinanceAccess = {
  payout: 'none',
  vendorCommissions: 'none',
  vendorGrid: 'none',
  settings: 'none',
};

/**
 * Ce que l'API ouvre à la personne connectée côté rémunération
 * (`GET /finance/access`) — pour n'afficher que des portes ouvertes. UX
 * seulement : chaque route revérifie drapeau, réglage du réseau et périmètre.
 *
 * Jamais en session PIN (tablette partagée) : la requête n'est pas même
 * envoyée, et tout est fermé. Rien n'est gardé sur l'appareil (TanStack
 * Query en mémoire, `/finance/*` hors service worker).
 */
export function useFinanceAccess(): MyFinanceAccess {
  const me = useApiQuery<User>(['me'], '/users/me');
  const flags = useFeatureFlags();
  const pin = me.data ? me.data.authLevel === 'pin' : isActingAs();
  const enabled =
    !!me.data && !pin && (me.data.role === 'admin' || flags.financeVisibility === 'everyone');
  const q = useApiQuery<MyFinanceAccess>(['finance', 'access'], enabled && '/finance/access');
  return enabled && q.data ? q.data : NONE;
}
